import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL as string;
export const api = axios.create({ baseURL: `${BACKEND_URL}/api`, withCredentials: true });

// Cookie is the primary session; the Bearer fallback keeps sign-in working when the app and API are served from different origins.
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("sl_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const assetUrl = (url?: string | null) => {
  if (!url) return null;
  return url.startsWith("http") ? url : `${BACKEND_URL}${url}`;
};

export const BOKEH_FALLBACK =
  "https://images.unsplash.com/photo-1607202563005-cbaabe636953?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600";

export function errMsg(e: any): string {
  const d = e?.response?.data?.detail;
  if (!d) return e?.message || "Something went wrong";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return d?.message || d?.msg || d?.detail || (typeof d === "object" ? JSON.stringify(d) : String(d));
}

export const money = (v: number) => `$${(v || 0).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

export const fmtDate = (s?: string) => (s ? new Date(s).toLocaleString("en-US", { dateStyle: "medium", timeStyle: "short" }) : "—");

export async function uploadFile(file: File, kind: string) {
  const fd = new FormData();
  fd.append("file", file);
  fd.append("kind", kind);
  const { data } = await api.post("/files/upload", fd, { headers: { "Content-Type": "multipart/form-data" } });
  return data as { id: string; url: string; original_filename: string; content_type: string; size: number };
}
